var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-undo{fill:none;}.b-undo{fill:#484848;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a-undo",
    width: 24,
    height: 24,
    rx: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1231 -568)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a-undo",
    width: 24,
    height: 24,
    rx: 7,
    transform: "translate(1231 568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-undo",
    d: "M13660,21949.494h8.82l-4.415,4.508Zm2.972,0a8.315,8.315,0,0,1,2.593-5.32,7.977,7.977,0,0,1,5.46-2.172,7.847,7.847,0,0,1,1.476.131,8.2,8.2,0,0,0-6.588,7.361Z",
    transform: "translate(23191 -13086) rotate(90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undoIcon.6a2a425d7f6ef270bbb175836ffb8ed2.svg";
export { ForwardRef as ReactComponent };